import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperFunctionsService {

  constructor() { }

  public truncateText(text: string, length: number = 16): string {
    let textCopy: any = new String(text);

    textCopy = this.stripHTML(textCopy);
    textCopy = textCopy.split(' ');
    textCopy = textCopy.slice(0, length);
    textCopy = textCopy.join(' ');
    textCopy += '...';

    return textCopy;
  }

  public stripHTML(text: string): string {
    return text
      .replace(/(<([^>]+)>)/gi, '') // remove HTML
      .replace(/&nbsp;/gi, ' ') // remove non breaking spaces
      .replace(/\n/gi, '') // remove \n
      .replace(/\s{2}/gi, ''); // remove areas with there are over 2 white spaces
  }
}
